import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createSiblingIssue: {
		id: 'work-management-board.board.column.card.inline-sibling-create.create-sibling-issue',
		defaultMessage: 'Create work item',
		description: 'Label for the button that creates a new card in business board.',
	},
	createSiblingIssueAtTheTopOfColumnA11Y: {
		id: 'work-management-board.board.column.card.inline-sibling-create.create-sibling-issue-at-the-top-of-column-a11y',
		defaultMessage: 'Create work item at the top of the column',
		description:
			'A11Y Label for the button that creates a new card in business board at the top of the column. Only used for screen readers.',
	},
	createSiblingIssueA11Y: {
		id: 'work-management-board.board.column.card.inline-sibling-create.create-sibling-issue-a11y',
		defaultMessage: 'Create work item after work item {issueKey}',
		description:
			'A11Y Label for the button that creates a new card in business board. Only used for screen readers.',
	},
});
